import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] px-6">
      <div className="max-w-md w-full text-center rounded-2xl border border-[#27334D] bg-[#111726] p-10 animate-fade-up">
        <XCircle className="w-14 h-14 text-slate-500 mx-auto mb-5" />
        <h1 className="font-display text-xl font-semibold mb-2">Checkout cancelled</h1>
        <p className="text-slate-400 text-sm mb-6">No charge was made. You can upgrade any time.</p>
        <button onClick={() => navigate("/billing")} className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 px-6 py-3 rounded-lg font-medium text-sm transition-colors">Back to billing</button>
      </div>
    </div>
  );
}
